import React from 'react';

import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type AccountSummaryRowProps = {
    leftLabel: string;
    rightLabel: string;
};

export const AccountSummaryRow = ({ rightLabel, leftLabel }: AccountSummaryRowProps) => {
    return (
        <Row
            alignItems="center"
            justifyContent="space-between"
            paddingVertical="s12"
            borderBottomWidth={1}
            borderBottomColor={ds.colorToken.border.strong}
        >
            <Text variant="bodyMedium" pr="s12">
                {leftLabel}
            </Text>
            <Text variant="bodyMedium">{rightLabel}</Text>
        </Row>
    );
};
